import { TELEGRAM_SUPPORT_URL, WHATSAPP_SUPPORT_URL } from "@/config/site";

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
    <path d="M9.04 15.9l-.38 5.36c.55 0 .79-.24 1.08-.53l2.6-2.48 5.38 3.94c.99.55 1.7.26 1.97-.91L23.9 4.6c.32-1.45-.52-2.02-1.48-1.66L1.7 11.05c-1.41.55-1.39 1.34-.24 1.7l5.3 1.65L18.98 6.3c.58-.38 1.1-.17.67.21L9.04 15.9z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
    <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5.1-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-3-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.5.1-.2.2-.6.8-.7.9-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.6-1.2.1-.2 0-.4 0-.5l-.8-1.8c-.2-.5-.4-.4-.5-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s.9 2.5 1.1 2.7c.1.2 1.8 2.8 4.4 3.9.6.3 1.1.4 1.5.6.6.2 1.2.2 1.6.1.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.5-.3z" />
  </svg>
);

const SupportButton = ({ url, enabledTooltip, disabledTooltip, bg, testid, children }) => {
  const enabled = Boolean(url);
  const tooltip = enabled ? enabledTooltip : disabledTooltip;
  const classes = `group relative flex h-[52px] w-[52px] items-center justify-center rounded-full text-white transition-transform duration-200 ${
    enabled ? `${bg} hover:scale-105 shadow-[0_10px_30px_rgba(0,0,0,0.45)]` : `cursor-not-allowed ${bg}/45`
  }`;
  const inner = (
    <>
      <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-full border border-white/10 bg-[#12141d] px-3 py-1.5 text-xs text-foreground opacity-0 shadow-xl transition-opacity duration-200 group-hover:opacity-100">
        {tooltip}
      </span>
      {children}
    </>
  );
  return enabled ? (
    <a data-testid={testid} href={url} target="_blank" rel="noopener noreferrer" aria-label={tooltip} className={classes}>
      {inner}
    </a>
  ) : (
    <button data-testid={testid} aria-label={tooltip} disabled className={classes}>
      {inner}
    </button>
  );
};

export default function SupportDock() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="support-dock">
      <SupportButton
        url={WHATSAPP_SUPPORT_URL}
        enabledTooltip="Chat on WhatsApp"
        disabledTooltip="WhatsApp support coming soon"
        bg="bg-[#25D366]"
        testid="whatsapp-support-button"
      >
        <WhatsAppIcon />
      </SupportButton>
      <SupportButton
        url={TELEGRAM_SUPPORT_URL}
        enabledTooltip="Chat with support"
        disabledTooltip="Support chat coming soon"
        bg="bg-[#0088CC]"
        testid="telegram-support-button"
      >
        <TelegramIcon />
      </SupportButton>
    </div>
  );
}
